<template>
    <v-layout column class="content-directory">
        <v-flex xs12>
            <v-layout class="content-directory__list">
                <v-flex xs12>
                    <v-tabs
                            :class="activeTab === null ? 'bar-border' : ''"
                            v-model="activeTab"
                            color="white"
                            :mandatory="false"
                            hide-slider
                            mobile-break-point="600"
                    >
                        <v-tab v-for="ribbon in contentRibbonTitles"
                               :class="[
                                    isEnabledRibbon(ribbon) ? '' : 'disabled-tab',
                                    (contentSelectedFilters[ribbon.key] && contentSelectedFilters[ribbon.key].length) ? 'bold-ribbon' : '',
                                    currentRibbon && currentRibbon.name === ribbon.name ? 'active-filter-tab' : ''
                               ]"
                               :data-qe-id="`content-directory_${ribbon.key}`"
                               @click="selectedComponent(ribbon)"
                               :key="ribbon.key">
                            {{ribbon.name}}
                        </v-tab>
                        <v-tab-item
                                :transition="false"
                                :reverse-transition="false"
                                v-for="(ribbon, index) in contentRibbonTitles"
                                :key="index"
                                v-if="activeTab !== null">
                            <component class="content-directory__component"
                                       :is="determineComponent(ribbon)"
                                       v-bind="{ componentProps: { ...componentProps(ribbon) }}"
                            >
                            </component>
                        </v-tab-item>
                    </v-tabs>
                </v-flex>
            </v-layout>
            
        </v-flex>
        <v-flex xs12  justify-start>
            <content-filter-pills-list v-if="contentSelectedFilters"
                                       :handle-clear="removeAllFilters"
                                       :handle-close="removeFilter"
                                       :content-selected-filters="contentSelectedFiltersPillList">
            </content-filter-pills-list>
        </v-flex>
        <v-flex xs12>
            <v-layout class="rolodex-wrapper" v-if="showSortByDropDown || displayRolodex">
                <v-flex class="rolodex-wrapper__sort-by">
                    <sort-content-by-options v-if="showSortByDropDown"> </sort-content-by-options>
                </v-flex>
                <v-flex xs7 sm9 md10 class="rolodex-wrapper__rolodex">
                    <rolodex v-if="displayRolodex"
                             :set-directory-selected-letter="handleSelectedLetter"
                             :selected-letter-filter="contentDirectorySelectedLetterFilter"
                             :reset-selected-letter="removeSelectedLetter"
                             :filtered-letters-list="letterFilters">
                    </rolodex>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12>
            <content-search-results> </content-search-results>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { appCommonConstants } from "../appCommon.constants";
    import { appConstant } from "../../app.constant";
    import { numberCommaSeparated } from "../../common/utils/utils";
    import { contentRibbonTitles, contentDirectoryPageConstant } from "./contentDirectoryPage.constant";
    import { applyNumber } from "@/components/EventDirectoryPage/eventDirectoryPage.constants";
    import SortContentByOptions from "./SortByContent/SortByContentOptions";
    import ContentSearchResults from './ContentSearchResults/ContentSearchResults';
    import ContentFilterPillsList from "./FilterPill/ContentFilterPillsList";
    import ContentCommunityType from "./Ribbons/ContentCommunityType";
    import ContentCategory from "./Ribbons/ContentCategory";
    import ContentDate from "./Ribbons/ContentDate";
    import Rolodex from "../MemberDirectoryPage/Rolodex";

    export default {
        name: 'ContentDirectory',
        created() {
            const filtersFromRoute = this.$route.query.contentFilters ? JSON.parse(this.$route.query.contentFilters) : null;
            if (filtersFromRoute) {
                if (filtersFromRoute.letterFilter && filtersFromRoute.letterFilter.length) {
                    this.setContentSelectedLetterFilter(filtersFromRoute.letterFilter[0]);
                }
                sessionStorage.setItem(appConstant.storageKeys.contentDirectoryStoredFilters, JSON.stringify(filtersFromRoute));
            }
            const searchTextFromRoute = this.$route.query.contentSearchText ? this.$route.query.contentSearchText : '';
            this.setContentStateFromRouter({
                contentSearchText: searchTextFromRoute,
                filters: filtersFromRoute,
            });
            this.getContentDirectorySearchResults();
        },
        components: {
            Rolodex,
            ContentFilterPillsList,
            ContentSearchResults,
            SortContentByOptions,
            ContentCommunityType,
            ContentCategory,
            ContentDate,
        },
        data() {
            return {
                appCommonConstants,
                contentDirectoryPageConstant,
                contentRibbonTitles,
                activeTab: null,
                selectedRibbonFilter: null,
                currentComponent: null,
                currentRibbon: null,
            };
        },
        methods: {
            ...mapActions({
                getContentDirectorySearchResults: `contentDirectory/${storeAction.getInitialContentDirectorySearchResults}`,
                clearAllContentFilters: `contentDirectory/${storeAction.clearAllContentFilters}`,
            }),
            ...mapMutations({
                setContentStateFromRouter: `contentDirectory/${storeMutation.setContentStateFromRouter}`,
                setContentFiltersInState: `contentDirectory/${storeMutation.setContentFiltersInState}`,
                removeContentPillFromState: `contentDirectory/${storeMutation.removeContentPillFromState}`,
                setContentSelectedLetterFilter: `contentDirectory/${storeMutation.setContentSelectedLetterFilter}`,
            }),
            determineComponent() {
                return this.currentComponent;
            },
            componentProps(rib) {
                let ribbonFiltersFromAPI = this.contentDirectoryResult && this.contentDirectoryResult.searchRibbonGroup
                && this.contentDirectoryResult.searchRibbonGroup.length > 0
                    ? this.contentDirectoryResult.searchRibbonGroup.find(ribbon => ribbon.key === rib.key)
                    : {};

                //TODO: temporarily removing Files and Media for Hybrid UI release - until it is mobile ready
                if (this.isMobileAppBrowser && ribbonFiltersFromAPI
                    && ribbonFiltersFromAPI.filters && ribbonFiltersFromAPI.filters.length) {
                    ribbonFiltersFromAPI = {
                        ...ribbonFiltersFromAPI,
                        filters: ribbonFiltersFromAPI.filters
                            .filter(item => item.filterValue &&
                                item.filterValue.toLowerCase() !== contentDirectoryPageConstant.constant.filesAndMedia.toLowerCase()),
                    };
                }

                return {
                    currentRibbon: this.contentRibbonTitles.find(title => title.component === rib.component),
                    postAction: this.cancel,
                    labelWithCount: this.labelWithCount,
                    isPreviouslySelected: this.isPreviouslySelected,
                    showRibbonCheckboxOption: this.showRibbonCheckboxOption,
                    updateRoute: this.updateRoute,
                    applyNumberCount: this.applyNumberCount,
                    ribbonItemFromApi: ribbonFiltersFromAPI,
                    multiSelect: this.currentComponent !== contentDirectoryPageConstant.constant.contentDateComponent,
                    showCount: this.currentComponent !== contentDirectoryPageConstant.constant.contentDateComponent,
                };
            },
            selectedComponent(ribbon) {
                this.currentComponent = ribbon.component;
                this.currentRibbon = ribbon;
            },
            cancel() {
                this.activeTab = null;
                this.selectedRibbonFilter = null;
            },
            isEnabledRibbon(ribbon) {
                let result = false;
                if (this.contentDirectoryResult && this.contentDirectoryResult.searchRibbonGroup &&
                    this.contentDirectoryResult.searchRibbonGroup.length > 0) {
                    const ribbonFromApi = this.contentDirectoryResult.searchRibbonGroup.find(item => item.key === ribbon.key);
                    if (ribbonFromApi && ribbonFromApi.filters) {
                        result = ribbonFromApi.filters.some(item => item.count > 0 || item.isTypeAhead || item.isDropdown || (item.subFilters && item.subFilters.length));
                    }
                }
                return result;
            },
            showRibbonCheckboxOption(ribbonItem) {
                return ribbonItem.count > 0 || ribbonItem.isTypeAhead || ribbonItem.isDropdown || (ribbonItem.subFilters && ribbonItem.subFilters.length > 0);
            },
            numberCommaSeparated,
            labelWithCount(filterItem, parentKey) {
                const { count } = filterItem;
                let countToShow = null;

                if (count > 0) {
                    countToShow = `(${numberCommaSeparated(count)})`;
                    if (this.contentSelectedFilters && parentKey) {
                        const itemInSf = this.contentSelectedFilters[parentKey].length;
                        if (itemInSf) {
                            countToShow = null;
                        }
                    }
                }
                return countToShow;
            },
            isPreviouslySelected(filterItem, selectedFilterList) {
                let result = false;
                if (filterItem && selectedFilterList) {
                    const itemInSf = selectedFilterList
                        .find(item => item.filterValue === filterItem.filterValue && item.filterKey === filterItem.filterKey);
                    if (itemInSf) {
                        result = true;
                    }
                }
                return result;
            },
            updateRoute(parentKey, selectedFilters) {
                this.setContentFiltersInState({
                    key: parentKey,
                    filters: selectedFilters,
                });
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        contentFilters: JSON.stringify(this.contentSelectedFilters),
                        contentSearchText: this.contentSearchText || '',
                    },
                });
                sessionStorage.setItem(appConstant.storageKeys.contentDirectoryStoredFilters, JSON.stringify(this.contentSelectedFilters));
            },
            removeFilter(filterItem) {
                this.removeContentPillFromState(filterItem);
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        contentFilters: JSON.stringify(this.contentSelectedFilters),
                        contentSearchText: this.contentSearchText || '',
                    },
                });
                sessionStorage.setItem(appConstant.storageKeys.contentDirectoryStoredFilters, JSON.stringify(this.contentSelectedFilters));
            },
            removeAllFilters() {
                let dataFromRoute = { ...this.$route.query };
                if (dataFromRoute && dataFromRoute.hasOwnProperty('contentFilters')) {
                    delete dataFromRoute.contentFilters;
                }

                if (this.contentDirectorySelectedLetterFilter) {
                    dataFromRoute = {
                        contentFilters: JSON.stringify({
                            letterFilter: [{ ...this.contentDirectorySelectedLetterFilter }],
                        }),
                    };
                }

                this.$router.push({
                    query: { ...dataFromRoute },
                });

                if (this.contentDirectorySelectedLetterFilter) {
                    sessionStorage.setItem(
                        appConstant.storageKeys.contentDirectoryStoredFilters,
                        JSON.stringify({ letterFilter: [{ ...this.contentDirectorySelectedLetterFilter }] }),
                    );
                } else {
                    this.clearAllContentFilters();
                    sessionStorage.removeItem(appConstant.storageKeys.contentDirectoryStoredFilters);
                }
            },
            applyNumberCount(newlySelected) {
                return applyNumber(this.contentSelectedFilters[this.currentRibbon.key], newlySelected);
            },
            handleSelectedLetter(letterFilter) {
                this.setContentSelectedLetterFilter(letterFilter);
                this.updateRoute('letterFilter', [letterFilter]);
            },
            removeSelectedLetter() {
                this.removeFilter(this.contentDirectorySelectedLetterFilter);
                this.setContentSelectedLetterFilter();
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                contentDirectoryResult: `contentDirectory/${storeGetters.contentDirectorySearchResults}`,
                contentState: `contentDirectory/${storeGetters.contentState}`,
                contentSelectedFilters: `contentDirectory/${storeGetters.contentSelectedFilters}`,
                contentSearchText: `contentDirectory/${storeGetters.contentDirectorySearchText}`,
                contentDirectorySelectedLetterFilter: `contentDirectory/${storeGetters.contentDirectorySelectedLetterFilter}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            contentSelectedFiltersPillList() {
                const selectedFilterPillObject = {
                    ...this.contentSelectedFilters,
                };

                if (selectedFilterPillObject.hasOwnProperty('letterFilter')) {
                    delete selectedFilterPillObject.letterFilter;
                }
                return selectedFilterPillObject;
            },
            showSortByDropDown() {
                return this.contentDirectoryResult && this.contentDirectoryResult.searchResults &&
                    (this.contentDirectoryResult.searchResults.length > 0 || this.contentDirectorySelectedLetterFilter);
            },
            displayRolodex() {
                return this.contentDirectoryResult && this.contentDirectoryResult.searchResults
                    && (this.contentDirectorySelectedLetterFilter || this.contentDirectoryResult.searchResults.length >
                        contentDirectoryPageConstant.constant.minimumCountForRolodex);
            },
            letterFilters() {
                return this.contentDirectoryResult && this.contentDirectoryResult.quickSearchResults
                && this.contentDirectoryResult.quickSearchResults[0]
                && this.contentDirectoryResult.quickSearchResults[0].filters
                    ? this.contentDirectoryResult.quickSearchResults[0].filters
                    : [];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .content-directory{
        &__ribbon {
            padding-left: 20px;
            border-bottom: 1px solid $ypo-medium-gray;
        }
        &__component {
            background-color: $ypo-extra-light-gray;
            border-bottom: 1px solid $ypo-light-gray-background;
            border-right: 1px solid $ypo-light-gray-background;
            border-left: 1px solid $ypo-light-gray-background;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
    }

    .filter-ribbon {
        padding-bottom: 10px;

        &__title {
            font-weight: 600;
            font-size: 16px !important;
            color: $black;
            font-family: 'Gentona', sans-serif;
            letter-spacing: 0.29px;
            line-height: 24px;
            padding: 5px 15px;
        }

        &__button {
            color: $ypo-cta;
            font-size: 16px;
            line-height: 37px;
            letter-spacing: 0.39px;
        }

    }

    .list-frame {
        background-color: $ypo-extra-light-gray;
        padding: 0 20px 30px 10px;
        border: 1px solid $ypo-light-gray;
        margin-top: -2px;
        border-bottom-left-radius: 8px !important;
        border-bottom-right-radius: 8px !important;

        &__title {
            color: $ypo-blue;
            font-family: "Noto Sans", sans-serif;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0.23px;
            line-height: 24px;
        }

        &__button {
            &-label {
                margin-right: 3px;
            }
        }

        &__actions {
            position: absolute;
            right: 15px;
            top: 5px;

        }
    }

    .bar-border {
        border-bottom: 1px solid $ypo-tile-border !important;
    }

    .bold-ribbon {
        color: $ypo-blue;
        font-weight: 600;
    }

    .rolodex-wrapper {
        padding-left: 5px;
        padding-top: 5px;
        border-bottom: 1px solid $ypo-light-medium-gray;

        @include breakpoint(xs) {
            padding-left: 10px !important;
        }

        &__sort-by {
            flex: 0 1 auto;
        }

        &__rolodex {
            margin-top: -8px;
        }
    }
</style>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_commonClasses.scss';

    .content-directory {
        @extend %ypo_checkbox;

        .disabled-tab {
            .v-tabs__item {
                pointer-events: none;
                color: $ypo-medium-gray !important;
            }
        }

        &__list {
            .v-tabs {
                &__item {
                    text-transform: none;
                    color: $ypo-cta;
                    font-size: 14px;
                    line-height: normal;
                    opacity: 1 !important;
                    z-index: 2;
                    padding: 10px 15px 0;

                    &--active {
                        background-color: $ypo-extra-light-gray;
                        border-top: 1px solid $ypo-light-gray;
                        border-right: 1px solid $ypo-light-gray;
                        border-left: 1px solid $ypo-light-gray;
                        border-top-left-radius: 8px;
                        border-top-right-radius: 8px;
                    }
                }
            }
        }
    }


</style>
